var _filter, _rect, _rect2, _rect3, _text, _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizeJpgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imgGrad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#42A5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1976D2"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F57C00"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow3",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 2,
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 45,
    height: 37,
    rx: 4,
    fill: "url(#imgGrad3)",
    filter: "url(#shadow3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 45,
    height: 37,
    rx: 4,
    fill: "none",
    stroke: "#0D47A1",
    strokeWidth: 2
  })), "\n\n  JPG label\n  ", _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 25,
    height: 10,
    rx: 2,
    fill: "#0D47A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 21,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "JPG")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 4,
    fill: "#FFD54F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 44 L24 30 L32 36 L44 24 L52 44 Z",
    fill: "#81D4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44 L28 32 L38 40 L52 44 Z",
    fill: "#4FC3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 14,
    fill: "url(#arrowGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56 L56 40",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 40 L56 50 M56 40 L46 40",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56 L40 46 M40 56 L50 56",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeJpgIcon);
export default __webpack_public_path__ + "static/media/resize-jpg-icon.2b38923d1fc235d3fcff58101c249c47.svg";
export { ForwardRef as ReactComponent };